"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompetencyClassificationT = exports.CompetencyFieldT = exports.SystemCompetencyField = exports.SystemCompetency = exports.CompetencyFieldTypeT = exports.CompetencyFieldType = exports.CompetencyDropdownT = exports.CompetencyDropdownOptionT = exports.CompetencyT = exports.CompetencySelfServeT = exports.CompetencySelfServe = exports.CompetencyTypeT = exports.CompetencyType = exports.EmployeeRoleT = exports.RoleT = exports.NoteTagLinkT = exports.NoteT = exports.NoteTagT = exports.CostCentreT = exports.JobCostCentreT = exports.JobT = exports.ChatMessageT = exports.ChatThreadT = exports.ManagerUserT = exports.EmployeeManagerT = exports.EmployeeT = exports.PendingEmployeeT = exports.ExtractedNoteInfoT = exports.ExtractedNoteInfoSuggestionsT = exports.CompanyT = exports.BanningOrderExceptionT = exports.ClassificationT = exports.AwardT = exports.AppraisalTemplateT = exports.AppraisalOutcomeT = exports.AppraisalT = exports.AppraisalDropdownOptionT = exports.AppraisalDropdownT = exports.AppraisalStatusT = exports.AppraisalStatus = exports.AppraisalAnswerT = exports.AppraisalAnswerValueT = exports.AppraisalQuestionT = exports.AppraisalQuestionKindT = exports.AppraisalQuestionKind = exports.AppraisalValueT = exports.AlertT = exports.AlertSeverityT = exports.PayrollDatabaseT = exports.PermissionsT = void 0;
exports.EmployeeSelfServeDataT = exports.DataModelHRT = exports.SettingsT = exports.StaticT = exports.BanningOrderT = exports.SalutationT = exports.SuperFundT = exports.UpdateFromPayrollT = exports.EmployeeOHST = exports.MediatorT = exports.AppraiserT = exports.DisciplineReviewT = exports.EmployeePerformanceT = exports.EmployeeTrainingT = exports.WorkTypeT = exports.TerminationTypeT = exports.PolicyConfirmationT = exports.PolicyClassificationT = exports.PolicyT = exports.ShiftWorkTypeT = exports.TaskPresetT = exports.TrainingClassEmplT = exports.TrainingSchedulesT = exports.TrainingScheduleAttendanceT = exports.TrainingCourseClassificationT = exports.TrainingProviderT = exports.TrainingCourseT = exports.PositionDescriptionT = exports.ContractT = exports.ContractFieldT = exports.ContractTemplateT = exports.EmployeeCompetencyFieldT = exports.EmployeeCompetencyT = exports.CompetencyLinkT = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const dates_1 = require("./dates");
const meta_types_1 = require("./meta-types");
exports.PermissionsT = tBox.Object({
    AuthLevel: tBox.Number(),
    CanFinaliseContracts: tBox.Boolean(),
    CanApproveOnboarding: tBox.Boolean(),
});
exports.PayrollDatabaseT = tBox.Object({
    ID: tBox.Number(),
    DatabaseName: (0, meta_types_1.MaybeT)(tBox.String()),
    DatabasePath: (0, meta_types_1.MaybeT)(tBox.String()),
    TriOnlineFacility: tBox.Number(),
    Client: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.AlertSeverityT = tBox.Union([
    tBox.Literal('info'),
    tBox.Literal('warning'),
    tBox.Literal('error'),
]);
exports.AlertT = tBox.Object({
    ID: tBox.String(),
    Employee: (0, meta_types_1.MaybeT)(tBox.Number()),
    Message: tBox.String(),
    SubMessage: (0, meta_types_1.MaybeT)(tBox.String()),
    Severity: exports.AlertSeverityT,
    Date: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    TypeKey: tBox.String(),
    TypeLabel: tBox.String(),
    Details: tBox.Union([
        tBox.Object({
            Type: tBox.Literal('appraisal'),
            AppraisalID: tBox.Number(),
        }),
        tBox.Object({
            Type: tBox.Literal('competency'),
            CompetencyID: tBox.Number(),
            LinkedCompetencyID: (0, meta_types_1.MaybeT)(tBox.Number()),
            EmployeeCompetencyID: (0, meta_types_1.MaybeT)(tBox.Number()),
        }),
        tBox.Object({
            Type: tBox.Literal('no_job'),
        }),
        tBox.Object({
            Type: tBox.Literal('note_tag'),
            NoteTagID: tBox.Number(),
        }),
        tBox.Object({
            Type: tBox.Literal('policy_confirmation'),
            PolicyID: tBox.Number(),
        }),
        tBox.Object({
            Type: tBox.Literal('banning_order'),
            Count: tBox.Number(),
        }),
        tBox.Object({
            Type: tBox.Literal('training_course'),
            CourseID: tBox.Number(),
        }),
    ]),
});
exports.AppraisalValueT = tBox.Object({
    ID: tBox.Number(),
    Template: tBox.Number(),
    Appraisal: (0, meta_types_1.MaybeT)(tBox.Number()),
    IsQuestion: meta_types_1.tBoolT,
    IsManager: meta_types_1.tBoolT,
    Value: tBox.String(),
    Deleted: meta_types_1.tBoolT,
});
var AppraisalQuestionKind;
(function (AppraisalQuestionKind) {
    AppraisalQuestionKind[AppraisalQuestionKind["Text"] = 1] = "Text";
    AppraisalQuestionKind[AppraisalQuestionKind["Discrete"] = 2] = "Discrete";
    AppraisalQuestionKind[AppraisalQuestionKind["Note"] = 3] = "Note";
})(AppraisalQuestionKind || (exports.AppraisalQuestionKind = AppraisalQuestionKind = {}));
exports.AppraisalQuestionKindT = tBox.Enum(AppraisalQuestionKind);
exports.AppraisalQuestionT = tBox.Object({
    ID: tBox.Number(),
    Template: tBox.Number(),
    Appraisal: (0, meta_types_1.MaybeT)(tBox.Number()),
    Title: tBox.String(),
    IsEmployee: meta_types_1.tBoolT,
    IsManager: meta_types_1.tBoolT,
    Value: tBox.String(),
    DiscreteOptions: (0, meta_types_1.MaybeT)(tBox.Number()),
    Order: tBox.Number(),
    Kind: exports.AppraisalQuestionKindT,
    Answer: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.AppraisalAnswerValueT = tBox.Object({
    Kind: exports.AppraisalQuestionKindT,
    Value: (0, meta_types_1.MaybeT)(tBox.Number()),
    Note: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.AppraisalAnswerT = tBox.Object({
    ID: tBox.Number(),
    Question: tBox.Number(),
    IsManager: meta_types_1.tBoolT,
    Value: exports.AppraisalAnswerValueT,
});
var AppraisalStatus;
(function (AppraisalStatus) {
    AppraisalStatus[AppraisalStatus["Scheduled"] = 0] = "Scheduled";
    AppraisalStatus[AppraisalStatus["Pending"] = 1] = "Pending";
    AppraisalStatus[AppraisalStatus["Reviewing"] = 2] = "Reviewing";
    AppraisalStatus[AppraisalStatus["Meeting"] = 3] = "Meeting";
    AppraisalStatus[AppraisalStatus["Complete"] = 4] = "Complete";
})(AppraisalStatus || (exports.AppraisalStatus = AppraisalStatus = {}));
exports.AppraisalStatusT = tBox.Enum(AppraisalStatus);
exports.AppraisalDropdownT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Disabled: meta_types_1.tBoolT,
});
exports.AppraisalDropdownOptionT = tBox.Object({
    ID: tBox.Number(),
    DropdownID: tBox.Number(),
    Text: tBox.String(),
    Value: tBox.Number(),
    Disabled: meta_types_1.tBoolT,
});
exports.AppraisalT = tBox.Object({
    ID: tBox.Number(),
    Appraiser: (0, meta_types_1.MaybeT)(tBox.Number()),
    Employee: tBox.Number(),
    Template: tBox.Number(),
    DueDate: (0, dates_1.DateObjT)(),
    Finalised: meta_types_1.tBoolT,
    MeetingRequested: meta_types_1.tBoolT,
    Note: (0, meta_types_1.MaybeT)(tBox.String()),
    Outcome: (0, meta_types_1.MaybeT)(tBox.Number()),
    ManagerQuestions: tBox.Array(tBox.Number()),
    EmployeeQuestions: tBox.Array(tBox.Number()),
    EmployeeAnswered: meta_types_1.tBoolT,
    ManagerAnswered: meta_types_1.tBoolT,
    EmployeeFinalNote: (0, meta_types_1.MaybeT)(tBox.String()),
    ManagerFinalNote: (0, meta_types_1.MaybeT)(tBox.String()),
    Notified: meta_types_1.tBoolT,
    Status: exports.AppraisalStatusT,
});
exports.AppraisalOutcomeT = tBox.Object({
    ID: tBox.Number(),
    Value: tBox.String(),
    RequiresFollowup: meta_types_1.tBoolT,
    Disabled: meta_types_1.tBoolT,
});
exports.AppraisalTemplateT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Classifications: tBox.Array(tBox.Number()),
    Roles: tBox.Array(tBox.Number()),
    Disabled: tBox.Union([tBox.Literal(0), tBox.Literal(1)]),
    DefaultAppraiser: (0, meta_types_1.MaybeT)(tBox.Number()),
    EmployeeQuestions: tBox.Array(tBox.Number()),
    ManagerQuestions: tBox.Array(tBox.Number()),
    RepeatMonths: (0, meta_types_1.MaybeT)(tBox.Number({
        description: 'The number of months after the first instance (if set) that additional instances of this appraisal will be created',
    })),
    InitialMonths: (0, meta_types_1.MaybeT)(tBox.Number({
        description: 'The number of months after the job start date the first instance of this appraisal will be created',
    })),
    StartDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)('The earliest date this appraisal can be instantiated')),
    EmployeeNotificationWindow: tBox.Number(),
    AppraiserNotificationWindow: tBox.Number(),
    PreviousVersion: (0, meta_types_1.MaybeT)(tBox.Number()),
    CreatedBy: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.AwardT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    State: tBox.String(),
    Notes: tBox.String(),
    Active: (0, meta_types_1.MaybeT)(tBox.Number()),
    PayrollDatabase: tBox.Number(),
    PayrollAwardCode: tBox.Number(),
});
exports.ClassificationT = tBox.Object({
    ID: tBox.Number(),
    Award: tBox.Number(),
    Classification: tBox.String(),
    ClassDesc: tBox.String(),
    Active: (0, meta_types_1.MaybeT)(tBox.Number()),
    PayrollDatabase: tBox.Number(),
    PayrollClassCode: tBox.Number(),
    DefaultCC: tBox.Number(),
});
exports.BanningOrderExceptionT = tBox.Object({
    ID: tBox.Number(),
    Employee: tBox.Number(),
    BanningOrder: tBox.Number(),
    FlaggedAt: (0, dates_1.DateTimeObjT)(),
    ApprovedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    ApprovedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    IsAutoApproved: meta_types_1.tBoolT,
    ReviewReason: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.CompanyT = tBox.Object({
    ID: tBox.Number(),
    Code: (0, meta_types_1.MaybeT)(tBox.String()),
    Address: tBox.String(),
    City: tBox.String(),
    Postcode: (0, meta_types_1.MaybeT)(tBox.Union([tBox.String(), tBox.Number()])),
    Contact: (0, meta_types_1.MaybeT)(tBox.String()),
    Phone: (0, meta_types_1.MaybeT)(tBox.String()),
    Fax: (0, meta_types_1.MaybeT)(tBox.String()),
    MainCo: (0, meta_types_1.MaybeT)(tBox.Number()),
    BedNum: (0, meta_types_1.MaybeT)(tBox.Number()),
    BankBSB: (0, meta_types_1.MaybeT)(tBox.String()),
    BankAccount: (0, meta_types_1.MaybeT)(tBox.String()),
    LegalEntity: (0, meta_types_1.MaybeT)(tBox.Number()),
    Active: tBox.Number(),
    State: tBox.String(),
    Name: tBox.String(),
    PayrollDatabase: tBox.Number(),
    PayrollCompanyCode: tBox.Number(),
});
exports.ExtractedNoteInfoSuggestionsT = tBox.Object({
    Competency: tBox.Union([
        tBox.Null(),
        tBox.Object({
            CompetencyType: tBox.String({ description: 'Name of the competency type' }),
            IssueDate: (0, meta_types_1.MaybeT)(tBox.String({ description: 'YYYY-MM-DD' })),
            ExpiryDate: (0, meta_types_1.MaybeT)(tBox.String({ description: 'YYYY-MM-DD' })),
            ExtraFields: tBox.Array(tBox.Object({
                FieldName: tBox.String(),
                Value: tBox.String(),
            }), {
                description: 'Only include fields defined for the competency, and only if you have information',
            }),
            Notes: (0, meta_types_1.MaybeT)(tBox.String({ description: 'Include any misc info in the textbox here' })),
        }),
    ]),
    MaxFortnightlyHours: (0, meta_types_1.MaybeT)(tBox.Number({
        description: 'Only include this if the visa conditions explicitly state that the employee has a maximum number of hours they can work',
    })),
});
exports.ExtractedNoteInfoT = tBox.Object({
    LogID: tBox.Number(),
    CreatedAt: (0, dates_1.DateTimeObjT)(),
    Suggestions: (0, meta_types_1.MaybeT)(exports.ExtractedNoteInfoSuggestionsT),
});
exports.PendingEmployeeT = tBox.Object({
    ID: tBox.Number(),
    Employee: (0, meta_types_1.MaybeT)(tBox.Number()),
    Email: tBox.String(),
    Surname: tBox.String(),
    FirstName: tBox.String(),
    DontSyncWithPayroll: meta_types_1.tBoolT,
    InitialClassification: (0, meta_types_1.MaybeT)(tBox.Number()),
    Roles: tBox.Array(tBox.Number()),
    StartDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    PayrollCompany: (0, meta_types_1.MaybeT)(tBox.Number()),
    PayrollCostCentre: (0, meta_types_1.MaybeT)(tBox.Number()),
    WorkType: (0, meta_types_1.MaybeT)(tBox.Union([tBox.Literal('F'), tBox.Literal('P'), tBox.Literal('C')])),
    Status: tBox.Number(),
    AuthToken: (0, meta_types_1.MaybeT)(tBox.String()),
    CreatedAt: (0, dates_1.DateTimeObjT)(),
    CreatedBy: tBox.Number(),
    SentAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    SentBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    LogEmailID: (0, meta_types_1.MaybeT)(tBox.Number()),
    SubmittedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    ApprovedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    ApprovedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    ContractTemplate: (0, meta_types_1.MaybeT)(tBox.Number()),
    ContractFields: tBox.Record(tBox.String(), (0, meta_types_1.MaybeT)(tBox.String())),
    ContractFile: (0, meta_types_1.MaybeT)(tBox.String()),
    ApprovedContract: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    SecondName: (0, meta_types_1.MaybeT)(tBox.String()),
    PreferredName: (0, meta_types_1.MaybeT)(tBox.String()),
    SalutationTitle: (0, meta_types_1.MaybeT)(tBox.String()),
    Gender: (0, meta_types_1.MaybeT)(tBox.String()),
    DateOfBirth: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Address: (0, meta_types_1.MaybeT)(tBox.String()),
    City: (0, meta_types_1.MaybeT)(tBox.String()),
    State: (0, meta_types_1.MaybeT)(tBox.String()),
    PostCode: (0, meta_types_1.MaybeT)(tBox.String()),
    Country: (0, meta_types_1.MaybeT)(tBox.String()),
    MobileNo: (0, meta_types_1.MaybeT)(tBox.String()),
    EmergencyContactName: (0, meta_types_1.MaybeT)(tBox.String()),
    EmergencyContactPhone: (0, meta_types_1.MaybeT)(tBox.String()),
    EmergencyContactRelation: (0, meta_types_1.MaybeT)(tBox.String()),
    NextOfKinName: (0, meta_types_1.MaybeT)(tBox.String()),
    NextOfKinRelation: (0, meta_types_1.MaybeT)(tBox.String()),
    NextOfKinPhone: (0, meta_types_1.MaybeT)(tBox.String()),
    IsATSI: meta_types_1.BooleanOptionalAnswerT,
    IsCALD: meta_types_1.BooleanOptionalAnswerT,
    HasDisability: meta_types_1.BooleanOptionalAnswerT,
    RightToWorkType: (0, meta_types_1.MaybeT)(tBox.Number()),
    BankBSB: (0, meta_types_1.MaybeT)(tBox.String()),
    BankAccNumber: (0, meta_types_1.MaybeT)(tBox.String()),
    TaxFileNumber: (0, meta_types_1.MaybeT)(tBox.String()),
    TaxCode: (0, meta_types_1.MaybeT)(tBox.String()),
    HasStudentLoans: (0, meta_types_1.MaybeT)(meta_types_1.tBoolT),
    SuperannuationType: (0, meta_types_1.MaybeT)(tBox.Number()),
    SuperUSI: (0, meta_types_1.MaybeT)(tBox.String()),
    SuperMemberNumber: (0, meta_types_1.MaybeT)(tBox.String()),
    Notes: tBox.Array(tBox.Object({
        ID: tBox.Number(),
        Title: (0, meta_types_1.MaybeT)(tBox.String()),
        Text: (0, meta_types_1.MaybeT)(tBox.String()),
        Attachment: (0, meta_types_1.MaybeT)(tBox.String()),
        AttachmentMime: (0, meta_types_1.MaybeT)(tBox.String()),
        CreatedAt: (0, dates_1.DateTimeObjT)(),
        CreatedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
        IsEmployeeViewable: meta_types_1.tBoolT,
        Tags: tBox.Array(tBox.Number()),
        ExtractedInfo: (0, meta_types_1.MaybeT)(exports.ExtractedNoteInfoT),
    })),
    PolicyConfirmations: tBox.Array(tBox.Object({
        ID: tBox.Number(),
        Policy: tBox.Number(),
        ConfirmedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    })),
    PositionDescriptions: tBox.Array(tBox.Object({
        ID: tBox.Number(),
        Name: tBox.String(),
        Role: tBox.Number(),
        PDFile: tBox.String(),
        CreatedAt: (0, dates_1.DateTimeObjT)(),
        CreatedBy: tBox.Number(),
        ConfirmedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    })),
});
exports.EmployeeT = tBox.Object({
    ID: tBox.Number(),
    Title: (0, meta_types_1.MaybeT)(tBox.String()),
    FullName: tBox.String({ dbExclude: true }),
    Surname: tBox.String(),
    FGiven: tBox.String(),
    SGiven: (0, meta_types_1.MaybeT)(tBox.String()),
    Address: (0, meta_types_1.MaybeT)(tBox.String()),
    City: (0, meta_types_1.MaybeT)(tBox.String()),
    State: (0, meta_types_1.MaybeT)(tBox.String()),
    PostCode: (0, meta_types_1.MaybeT)(tBox.Union([tBox.String(), tBox.Number()])),
    Phone: (0, meta_types_1.MaybeT)(tBox.String()),
    Mobile: (0, meta_types_1.MaybeT)(tBox.String()),
    Email: (0, meta_types_1.MaybeT)(tBox.String()),
    Gender: (0, meta_types_1.MaybeT)(tBox.String()),
    DOB: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    StartDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Nok: (0, meta_types_1.MaybeT)(tBox.String()),
    NokPhone: (0, meta_types_1.MaybeT)(tBox.String()),
    NokRelation: (0, meta_types_1.MaybeT)(tBox.String()),
    Contact: (0, meta_types_1.MaybeT)(tBox.String()),
    ContactRelation: (0, meta_types_1.MaybeT)(tBox.String()),
    ContactPhone: (0, meta_types_1.MaybeT)(tBox.String()),
    Active: (0, meta_types_1.MaybeT)(meta_types_1.tBoolT),
    E_Photo: (0, meta_types_1.MaybeT)(tBox.String()),
    TaxNo: (0, meta_types_1.MaybeT)(tBox.String()),
    Aboriginal: meta_types_1.BooleanOptionalAnswerT,
    CALD: meta_types_1.BooleanOptionalAnswerT,
    Disability: meta_types_1.BooleanOptionalAnswerT,
    LastCheckedAlerts: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    PayrollDatabase: (0, meta_types_1.MaybeT)(tBox.Number()),
    PayrollEmpCode: (0, meta_types_1.MaybeT)(tBox.Number()),
    LastSentFairWorkCasual: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
});
exports.EmployeeManagerT = tBox.Object({
    ID: tBox.Number(),
    Employee: tBox.Number(),
    Manager: tBox.Number({ description: 'TriOnline user ID assigned as manager' }),
});
exports.ManagerUserT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    LinkedEmployeeIDs: tBox.Array(tBox.Number()),
});
exports.ChatThreadT = tBox.Object({
    ID: tBox.Number(),
    Employee: (0, meta_types_1.MaybeT)(tBox.Number()),
    PendingEmployee: (0, meta_types_1.MaybeT)(tBox.Number()),
    Title: (0, meta_types_1.MaybeT)(tBox.String()),
    CreatedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    CreatedAt: (0, dates_1.DateTimeObjT)(),
    ResolvedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    ResolvedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
});
exports.ChatMessageT = tBox.Object({
    ID: tBox.Number(),
    Thread: tBox.Number(),
    User: (0, meta_types_1.MaybeT)(tBox.Number()),
    Employee: (0, meta_types_1.MaybeT)(tBox.Number()),
    IsManager: meta_types_1.tBoolT,
    Text: (0, meta_types_1.MaybeT)(tBox.String()),
    Attachment: (0, meta_types_1.MaybeT)(tBox.String()),
    EmployeeVisible: meta_types_1.tBoolT,
    CreatedAt: (0, dates_1.DateTimeObjT)(),
});
exports.JobT = tBox.Object({
    ID: tBox.Number(),
    Company: (0, meta_types_1.MaybeT)(tBox.Number()),
    Classification: tBox.Number(),
    Employee: tBox.Number(),
    Contract: (0, meta_types_1.MaybeT)(tBox.Number()),
    AnnivDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    SickAnnivDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    LongsAnniv: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    LSLAnnivDateAdj: (0, meta_types_1.MaybeT)(tBox.Number()),
    WorkType: tBox.Number({ description: '(1) Full Time, (2/3) Part Time, (4) Casual' }),
    PubHolsOpt: (0, meta_types_1.MaybeT)(tBox.Number()),
    AdoOpt: (0, meta_types_1.MaybeT)(tBox.Number()),
    RdoAcc: (0, meta_types_1.MaybeT)(tBox.Number()),
    RdoMove: (0, meta_types_1.MaybeT)(tBox.Number()),
    PrevExpHours: tBox.Number(),
    SiteExpHours: tBox.Number(),
    ArchSiteExpHours: (0, meta_types_1.MaybeT)(tBox.Number()),
    JobStartDate: (0, dates_1.DateObjT)(),
    JobEndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    ContractHours: (0, meta_types_1.MaybeT)(tBox.Number()),
    SkillsStartDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    LastYearExpChange: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    CurrYearExp: tBox.Number(),
    AccLieu: (0, meta_types_1.MaybeT)(tBox.Number()),
    LegacyKey: (0, meta_types_1.MaybeT)(tBox.String()),
    Category: (0, meta_types_1.MaybeT)(tBox.Number()),
    Accrued: (0, meta_types_1.MaybeT)(tBox.String()),
    ArchTaken: (0, meta_types_1.MaybeT)(tBox.Number()),
    PrevAccRued: (0, meta_types_1.MaybeT)(tBox.Number()),
    PrevArchTaken: (0, meta_types_1.MaybeT)(tBox.Number()),
    Movement: (0, meta_types_1.MaybeT)(tBox.Number()),
    ShiftWorkType: (0, meta_types_1.MaybeT)(tBox.Number()),
    TerminationType: (0, meta_types_1.MaybeT)(tBox.Number()),
    Active: tBox.Number(),
    DefaultJob: meta_types_1.tBoolT,
    PayrollDatabase: tBox.Number(),
    PayrollJobCode: tBox.Number(),
});
exports.JobCostCentreT = tBox.Object({
    ID: tBox.Number(),
    Job: tBox.Number(),
    SplitPercent: tBox.Number(),
    PayrollDatabase: tBox.Number(),
    CostCentre: tBox.Number(),
});
exports.CostCentreT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    PrintCode: (0, meta_types_1.MaybeT)(tBox.String()),
    SuperCC: (0, meta_types_1.MaybeT)(tBox.Number()),
    PayrollDatabase: tBox.Number(),
    PayrollCostCentreCode: tBox.Number(),
});
exports.NoteTagT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Description: tBox.String(),
    Colour: tBox.String(),
    RequiredSeverity: (0, meta_types_1.MaybeT)(tBox.Number({ description: '(1) warning, (2) error' })),
    GrandfatherDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    TemplateDocument: (0, meta_types_1.MaybeT)(tBox.String()),
    CanEmployeeSelfServe: meta_types_1.tBoolT,
});
exports.NoteT = tBox.Object({
    ID: tBox.Number(),
    Employee: (0, meta_types_1.MaybeT)(tBox.Number()),
    Title: (0, meta_types_1.MaybeT)(tBox.String()),
    Text: (0, meta_types_1.MaybeT)(tBox.String()),
    Attachment: (0, meta_types_1.MaybeT)(tBox.String()),
    AttachmentMime: (0, meta_types_1.MaybeT)(tBox.String()),
    CreatedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    CreatedAt: (0, dates_1.DateTimeObjT)(),
    DeletedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    DeletedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    EmployeeViewable: meta_types_1.tBoolT,
    ExtractedInfo: (0, meta_types_1.MaybeT)(exports.ExtractedNoteInfoT),
    ExtractedFlaggedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    LastMod: (0, dates_1.DateTimeObjT)(),
});
exports.NoteTagLinkT = tBox.Object({
    ID: tBox.Number(),
    Note: tBox.Number(),
    Tag: tBox.Number(),
});
exports.RoleT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Description: tBox.String(),
    PDDocument: (0, meta_types_1.MaybeT)(tBox.String()),
    IsActive: meta_types_1.tBoolT,
});
exports.EmployeeRoleT = tBox.Object({
    ID: tBox.Number(),
    Employee: tBox.Number(),
    Role: tBox.Number(),
});
var CompetencyType;
(function (CompetencyType) {
    CompetencyType[CompetencyType["LicenceRegistration"] = 1] = "LicenceRegistration";
    CompetencyType[CompetencyType["VisaPoliceCheck"] = 2] = "VisaPoliceCheck";
    CompetencyType[CompetencyType["Certification"] = 3] = "Certification";
    CompetencyType[CompetencyType["Qualification"] = 4] = "Qualification";
    CompetencyType[CompetencyType["Skill"] = 5] = "Skill";
})(CompetencyType || (exports.CompetencyType = CompetencyType = {}));
exports.CompetencyTypeT = tBox.Union([
    tBox.Literal(1),
    tBox.Literal(2),
    tBox.Literal(3),
    tBox.Literal(4),
    tBox.Literal(5),
]);
var CompetencySelfServe;
(function (CompetencySelfServe) {
    CompetencySelfServe[CompetencySelfServe["Allowed"] = 1] = "Allowed";
    CompetencySelfServe[CompetencySelfServe["Approval"] = 2] = "Approval";
    CompetencySelfServe[CompetencySelfServe["NotAllowed"] = 3] = "NotAllowed";
})(CompetencySelfServe || (exports.CompetencySelfServe = CompetencySelfServe = {}));
exports.CompetencySelfServeT = tBox.Union([
    tBox.Literal(1),
    tBox.Literal(2),
    tBox.Literal(3),
    tBox.Literal('1'),
    tBox.Literal('2'),
    tBox.Literal('3'),
]);
exports.CompetencyT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Description: (0, meta_types_1.MaybeT)(tBox.String()),
    Type: exports.CompetencyTypeT,
    HasExpirationDate: meta_types_1.tBoolT,
    HasIssueDate: meta_types_1.tBoolT,
    SelfServe: exports.CompetencySelfServeT,
    RequireAttachment: meta_types_1.tBoolT,
    IsMedical: meta_types_1.tBoolT,
    DaysNoticeEmpl: tBox.Number(),
    DaysNoticeManager: tBox.Number(),
    DefaultExpiryMonths: (0, meta_types_1.MaybeT)(tBox.Number()),
    GrandfatherDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
});
exports.CompetencyDropdownOptionT = tBox.Object({
    ID: tBox.Number(),
    Text: tBox.String(),
    DropdownID: tBox.Number(),
    Disabled: meta_types_1.tBoolT,
});
exports.CompetencyDropdownT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Options: tBox.Array(exports.CompetencyDropdownOptionT),
    Disabled: meta_types_1.tBoolT,
});
var CompetencyFieldType;
(function (CompetencyFieldType) {
    CompetencyFieldType["Text"] = "1";
    CompetencyFieldType["Date"] = "2";
    CompetencyFieldType["Checkbox"] = "3";
    CompetencyFieldType["Number"] = "4";
    CompetencyFieldType["Dropdown"] = "5";
})(CompetencyFieldType || (exports.CompetencyFieldType = CompetencyFieldType = {}));
exports.CompetencyFieldTypeT = tBox.Union([
    tBox.Literal('1'),
    tBox.Literal('2'),
    tBox.Literal('3'),
    tBox.Literal('4'),
    tBox.Literal('5'),
]);
var SystemCompetency;
(function (SystemCompetency) {
    SystemCompetency[SystemCompetency["PoliceCheck"] = 1] = "PoliceCheck";
    SystemCompetency[SystemCompetency["NurseRegistration"] = 2] = "NurseRegistration";
    SystemCompetency[SystemCompetency["VisaTemporary"] = 3] = "VisaTemporary";
    SystemCompetency[SystemCompetency["WorkingWithChildren"] = 4] = "WorkingWithChildren";
    SystemCompetency[SystemCompetency["AustralianCitizenshipCertificate"] = 5] = "AustralianCitizenshipCertificate";
    SystemCompetency[SystemCompetency["RightToWork"] = 6] = "RightToWork";
    SystemCompetency[SystemCompetency["AustralianPassportCitizenship"] = 7] = "AustralianPassportCitizenship";
    SystemCompetency[SystemCompetency["AustralianBirthCertificateCitizenship"] = 8] = "AustralianBirthCertificateCitizenship";
    SystemCompetency[SystemCompetency["VisaPermanentResident"] = 9] = "VisaPermanentResident";
})(SystemCompetency || (exports.SystemCompetency = SystemCompetency = {}));
var SystemCompetencyField;
(function (SystemCompetencyField) {
    SystemCompetencyField[SystemCompetencyField["VisaTempSubclass"] = 6] = "VisaTempSubclass";
    SystemCompetencyField[SystemCompetencyField["VisaPermSubclass"] = 14] = "VisaPermSubclass";
})(SystemCompetencyField || (exports.SystemCompetencyField = SystemCompetencyField = {}));
exports.CompetencyFieldT = tBox.Object({
    ID: tBox.Number(),
    CompetencyID: tBox.Number(),
    Label: tBox.String(),
    Type: (0, meta_types_1.MaybeT)(exports.CompetencyFieldTypeT),
    DropdownID: (0, meta_types_1.MaybeT)(tBox.Number()),
    IsCompulsory: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.CompetencyClassificationT = tBox.Object({
    ID: tBox.Number(),
    Competency: tBox.Number(),
    Classification: (0, meta_types_1.MaybeT)(tBox.Number()),
    Role: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.CompetencyLinkT = tBox.Object({
    ID: tBox.Number(),
    SourceCompetency: tBox.Number(),
    TargetCompetency: tBox.Number(),
    IsFullSubstitute: meta_types_1.tBoolT,
});
exports.EmployeeCompetencyT = tBox.Object({
    ID: tBox.Number(),
    Competency: tBox.Number(),
    Employee: tBox.Number(),
    IssueDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    ExpiryDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Attachment: (0, meta_types_1.MaybeT)(tBox.String()),
    Notes: (0, meta_types_1.MaybeT)(tBox.String()),
    EmployeeNotified: meta_types_1.tBoolT,
    ManagerNotified: meta_types_1.tBoolT,
});
exports.EmployeeCompetencyFieldT = tBox.Object({
    ID: tBox.Number(),
    EmployeeCompetency: tBox.Number(),
    CompetencyField: tBox.Number(),
    Value: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.ContractTemplateT = tBox.Object({
    ID: tBox.Number(),
    Title: tBox.String(),
    TemplateText: tBox.String(),
    CreatedBy: tBox.Number(),
    CreatedAt: (0, dates_1.DateTimeObjT)(),
    DeletedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    DeletedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    ts: (0, dates_1.DateTimeObjT)(),
});
exports.ContractFieldT = tBox.Object({
    StringCode: tBox.String(),
    FriendlyName: (0, meta_types_1.MaybeT)(tBox.String()),
    DefaultValue: (0, meta_types_1.MaybeT)(tBox.String()),
    IsActive: meta_types_1.tBoolT,
});
exports.ContractT = tBox.Object({
    ID: tBox.Number(),
    Employee: tBox.Number(),
    ContractTemplate: tBox.Number(),
    Fields: tBox.String(),
    Status: tBox.Number(),
    CreatedAt: (0, dates_1.DateTimeObjT)(),
    CreatedBy: tBox.Number(),
    FinalisedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    FinalisedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    SignedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    SignedByUser: (0, meta_types_1.MaybeT)(tBox.Number()),
    SignedByOnboardID: (0, meta_types_1.MaybeT)(tBox.String()),
    ExpiredBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    ExpiredAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    HashCodePDF: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.PositionDescriptionT = tBox.Object({
    ID: tBox.Number(),
    Employee: tBox.Number(),
    Role: tBox.Number(),
    CreatedAt: (0, dates_1.DateTimeObjT)(),
    CreatedBy: tBox.Number(),
    SignedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    HashCodePDF: tBox.String(),
});
exports.TrainingCourseT = tBox.Object({
    ID: tBox.Number(),
    Renew: (0, meta_types_1.MaybeT)(tBox.Number()),
    Offer: (0, meta_types_1.MaybeT)(tBox.Number()),
    MustCompleteDuration: (0, meta_types_1.MaybeT)(tBox.Number()),
    ProviderKey: tBox.Number(),
    CourseName: tBox.String(),
    PresenterTitle: (0, meta_types_1.MaybeT)(tBox.String()),
    PresenterName: (0, meta_types_1.MaybeT)(tBox.String()),
    Address: (0, meta_types_1.MaybeT)(tBox.String()),
    Phone: (0, meta_types_1.MaybeT)(tBox.String()),
    Mobile: (0, meta_types_1.MaybeT)(tBox.String()),
    Email: (0, meta_types_1.MaybeT)(tBox.String()),
    MustComplete: (0, meta_types_1.MaybeT)(tBox.String()),
    Active: tBox.Number(),
    RenewMY: (0, meta_types_1.MaybeT)(tBox.String()),
    RenewD: (0, meta_types_1.MaybeT)(tBox.Number()),
    OfferMY: (0, meta_types_1.MaybeT)(tBox.String()),
    OfferD: (0, meta_types_1.MaybeT)(tBox.Number()),
    CompleteMY: (0, meta_types_1.MaybeT)(tBox.String()),
    CompleteD: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.TrainingProviderT = tBox.Object({
    ProviderKey: tBox.Number(),
    ProviderCode: (0, meta_types_1.MaybeT)(tBox.String()),
    ProviderDesc: tBox.String(),
    Address: (0, meta_types_1.MaybeT)(tBox.String()),
    City: (0, meta_types_1.MaybeT)(tBox.String()),
    PostCode: (0, meta_types_1.MaybeT)(tBox.Union([tBox.String(), tBox.Number()])),
    State: (0, meta_types_1.MaybeT)(tBox.String()),
    ContactName: (0, meta_types_1.MaybeT)(tBox.String()),
    Phone: (0, meta_types_1.MaybeT)(tBox.String()),
    Fax: (0, meta_types_1.MaybeT)(tBox.String()),
    Active: tBox.Number(),
});
exports.TrainingCourseClassificationT = tBox.Object({
    ID: tBox.Number(),
    Classification: (0, meta_types_1.MaybeT)(tBox.Number()),
    Course: tBox.Number(),
    Role: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.TrainingScheduleAttendanceT = tBox.Object({
    ID: tBox.Number(),
    Schedule: tBox.Number(),
    Employee: (0, meta_types_1.MaybeT)(tBox.Number()),
    DateCompleted: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    Notes: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.TrainingSchedulesT = tBox.Object({
    ID: tBox.Number(),
    Venue: (0, meta_types_1.MaybeT)(tBox.Number()),
    Course: tBox.Number(),
    Presenter: (0, meta_types_1.MaybeT)(tBox.String()),
    StartDate: (0, dates_1.DateTimeObjT)(),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    Active: tBox.Number(),
    Location: (0, meta_types_1.MaybeT)(tBox.String()),
    Phone: (0, meta_types_1.MaybeT)(tBox.String()),
    Mobile: (0, meta_types_1.MaybeT)(tBox.String()),
    Email: (0, meta_types_1.MaybeT)(tBox.String()),
    Notes: (0, meta_types_1.MaybeT)(tBox.String()),
    Company: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.TrainingClassEmplT = tBox.Object({
    EmployeeCode: tBox.Number(),
    JobCode: tBox.Number(),
    ClassKey: tBox.Number(),
    EmployeeName: tBox.String(),
});
exports.TaskPresetT = tBox.Object({
    ID: tBox.Number(),
    TriggerType: (0, meta_types_1.MaybeT)(tBox.Number()),
    TaskTitle: tBox.String(),
    Description: tBox.String(),
});
exports.ShiftWorkTypeT = tBox.Object({
    ID: tBox.Number(),
    Type: tBox.String(),
});
exports.PolicyT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    StartDate: (0, dates_1.DateObjT)(),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Created: (0, dates_1.DateTimeObjT)(),
    FileChecksum: tBox.String(),
    NotifyDays: tBox.Number(),
    GrandfatherDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    WorkType: (0, meta_types_1.MaybeT)(tBox.Number({
        description: '1: Full time | 2: Part time | 3: Casual | 4: Any kind of permanent (full time + part time)',
    })),
});
exports.PolicyClassificationT = tBox.Object({
    ID: tBox.Number(),
    Policy: tBox.Number(),
    Classification: (0, meta_types_1.MaybeT)(tBox.Number()),
    Role: (0, meta_types_1.MaybeT)(tBox.Number()),
});
exports.PolicyConfirmationT = tBox.Object({
    ID: tBox.Number(),
    Employee: tBox.Number(),
    Policy: tBox.Number(),
    FirstNotified: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    LastRenotified: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    Confirmed: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
});
exports.TerminationTypeT = tBox.Object({
    ID: tBox.Number(),
    Type: tBox.String(),
});
exports.WorkTypeT = tBox.Object({
    ID: tBox.Number(),
    Type: tBox.String(),
});
exports.EmployeeTrainingT = tBox.Object({
    Course: tBox.Number(),
    CourseName: tBox.String(),
    Schedule: tBox.Number(),
    DateCompleted: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Notes: tBox.String(),
});
exports.EmployeePerformanceT = tBox.Object({
    ID: tBox.Number(),
    Employee: tBox.Number(),
    AppraisalDate: (0, dates_1.DateObjT)(),
    Appraiser: tBox.Number(),
    JobClassification: tBox.Number(),
    Location: tBox.String(),
    Notified: (0, meta_types_1.MaybeT)(tBox.Number()),
    NotifiedBy: tBox.String(),
    NotificationDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    NotificationMean: (0, meta_types_1.MaybeT)(tBox.Number()),
    Confirmed: (0, meta_types_1.MaybeT)(tBox.Number()),
    FinalisedDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Active: (0, meta_types_1.MaybeT)(tBox.Number()),
    NextAppraisalDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Notes: (0, meta_types_1.MaybeT)(tBox.String()),
    Outcome: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.DisciplineReviewT = tBox.Object({
    ID: tBox.Number(),
    Employee: tBox.Number(),
    ReviewDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Mediator: tBox.Number(),
    Appraiser: tBox.Number(),
    Location: tBox.String(),
    FollowUpDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    FinalisedDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    User: (0, meta_types_1.MaybeT)(tBox.Number()),
    Active: tBox.Number(),
    Notes: (0, meta_types_1.MaybeT)(tBox.String()),
    Outcome: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.AppraiserT = tBox.Object({
    ID: tBox.Number(),
    AppraiserName: tBox.String(),
});
exports.MediatorT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
});
exports.EmployeeOHST = tBox.Object({
    ID: tBox.Number(),
    Employee: tBox.Number(),
    IncidentDate: (0, dates_1.DateObjT)(),
    ReportingDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    OHSReporter: tBox.String(),
    Location: tBox.String(),
    Supervisor: tBox.Number(),
    ResidentsInvolved: (0, meta_types_1.MaybeT)(tBox.String()),
    EmployeesInvolved: (0, meta_types_1.MaybeT)(tBox.String()),
    Overview: (0, meta_types_1.MaybeT)(tBox.String()),
    Claimed: (0, meta_types_1.MaybeT)(tBox.Number()),
    IncidentClosed: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    Active: tBox.Number(),
});
exports.UpdateFromPayrollT = tBox.Object({
    ID: tBox.Number(),
    Database: tBox.Number(),
    AwardUpdate: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    EmployeeUpdate: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    CompanyUpdate: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    CostCentreUpdate: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    JobUpdate: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
});
exports.SuperFundT = tBox.Object({
    ID: tBox.Number(),
    USI: tBox.String(),
    SPIN: (0, meta_types_1.MaybeT)(tBox.String()),
    FundABN: tBox.String(),
    FundName: tBox.String(),
    ProductName: tBox.String(),
    HasRestrictions: meta_types_1.tBoolT,
});
exports.SalutationT = tBox.Object({
    Title: tBox.String(),
    Frequency: (0, meta_types_1.MaybeT)(tBox.Number()),
    Gender: (0, meta_types_1.MaybeT)(tBox.String()),
    FullTitle: tBox.String(),
    GenderAlt: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.BanningOrderT = tBox.Object({
    ID: tBox.Number(),
    FirstName: tBox.String(),
    MiddleName: (0, meta_types_1.MaybeT)(tBox.String()),
    Surname: tBox.String(),
    Alias: (0, meta_types_1.MaybeT)(tBox.String()),
    BanStart: (0, dates_1.DateTimeObjT)(),
    BanEnd: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    AddedAt: (0, dates_1.DateTimeObjT)(),
    DOB: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Description: (0, meta_types_1.MaybeT)(tBox.String()),
});
exports.StaticT = tBox.Object({
    superFunds: (0, meta_types_1.ModelTypeT)(exports.SuperFundT),
    salutations: (0, meta_types_1.ModelStrT)(exports.SalutationT),
    banningOrders: (0, meta_types_1.ModelTypeT)(exports.BanningOrderT),
});
exports.SettingsT = tBox.Object({
    ID: tBox.Number(),
    DefaultOnboardingEmail: tBox.String(),
    RequireContractToOnboard: meta_types_1.tBoolT,
    BlockRosterFromAddingEmployeesJobs: meta_types_1.tBoolT,
    KnowledgeBaseTabLabel: tBox.String(),
    KnowledgeBaseTitleText: tBox.String(),
    ScanNoteCompetencies: meta_types_1.tBoolT,
    EnableEmployeeChat: meta_types_1.tBoolT,
});
exports.DataModelHRT = tBox.Object({
    alerts: tBox.Record(tBox.Number(), tBox.Array(exports.AlertT)),
    appraisalAnswers: (0, meta_types_1.ModelTypeT)(exports.AppraisalAnswerT),
    appraisalDropdownOptions: (0, meta_types_1.ModelTypeT)(exports.AppraisalDropdownOptionT),
    appraisalDropdowns: (0, meta_types_1.ModelTypeT)(exports.AppraisalDropdownT),
    appraisalOutcomes: (0, meta_types_1.ModelTypeT)(exports.AppraisalOutcomeT),
    appraisalTemplates: (0, meta_types_1.ModelTypeT)(exports.AppraisalTemplateT),
    appraisalQuestions: (0, meta_types_1.ModelTypeT)(exports.AppraisalQuestionT),
    appraisals: (0, meta_types_1.ModelTypeT)(exports.AppraisalT),
    awards: (0, meta_types_1.ModelTypeT)(exports.AwardT),
    banningOrderExceptions: (0, meta_types_1.ModelTypeT)(exports.BanningOrderExceptionT),
    classifications: (0, meta_types_1.ModelTypeT)(exports.ClassificationT),
    companies: (0, meta_types_1.ModelTypeT)(exports.CompanyT),
    competencies: (0, meta_types_1.ModelTypeT)(exports.CompetencyT),
    competencyFields: (0, meta_types_1.ModelTypeT)(exports.CompetencyFieldT),
    competencyDropdowns: (0, meta_types_1.ModelTypeT)(exports.CompetencyDropdownT),
    competencyClassifications: (0, meta_types_1.ModelTypeT)(exports.CompetencyClassificationT),
    competencyLinks: (0, meta_types_1.ModelTypeT)(exports.CompetencyLinkT),
    contractTemplates: (0, meta_types_1.ModelTypeT)(exports.ContractTemplateT),
    contractFields: (0, meta_types_1.ModelStrT)(exports.ContractFieldT),
    contracts: (0, meta_types_1.ModelTypeT)(exports.ContractT),
    positionDescriptions: (0, meta_types_1.ModelTypeT)(exports.PositionDescriptionT),
    employees: (0, meta_types_1.ModelTypeT)(exports.EmployeeT),
    pendingEmployees: (0, meta_types_1.ModelTypeT)(exports.PendingEmployeeT),
    jobs: (0, meta_types_1.ModelTypeT)(exports.JobT),
    costCentre: (0, meta_types_1.ModelTypeT)(exports.CostCentreT),
    jobCostCentre: (0, meta_types_1.ModelTypeT)(exports.JobCostCentreT),
    notes: (0, meta_types_1.ModelTypeT)(exports.NoteT),
    noteTags: (0, meta_types_1.ModelTypeT)(exports.NoteTagT),
    noteTagLinks: (0, meta_types_1.ModelTypeT)(exports.NoteTagLinkT),
    employeeCompetencyFields: (0, meta_types_1.ModelTypeT)(exports.EmployeeCompetencyFieldT),
    employeeCompetencies: (0, meta_types_1.ModelTypeT)(exports.EmployeeCompetencyT),
    trainingCourses: (0, meta_types_1.ModelTypeT)(exports.TrainingCourseT),
    trainingProvider: (0, meta_types_1.ModelTypeT)(exports.TrainingProviderT),
    trainingCourseClassification: (0, meta_types_1.ModelTypeT)(exports.TrainingCourseClassificationT),
    trainingScheduleAttendance: (0, meta_types_1.ModelTypeT)(exports.TrainingScheduleAttendanceT),
    trainingSchedules: (0, meta_types_1.ModelTypeT)(exports.TrainingSchedulesT),
    policies: (0, meta_types_1.ModelTypeT)(exports.PolicyT),
    policyClassifications: (0, meta_types_1.ModelTypeT)(exports.PolicyClassificationT),
    policyConfirmations: (0, meta_types_1.ModelTypeT)(exports.PolicyConfirmationT),
    roles: (0, meta_types_1.ModelTypeT)(exports.RoleT),
    employeeRoles: (0, meta_types_1.ModelTypeT)(exports.EmployeeRoleT),
    employeeManagers: (0, meta_types_1.ModelTypeT)(exports.EmployeeManagerT),
    managerUsers: (0, meta_types_1.ModelTypeT)(exports.ManagerUserT),
    taskPresets: (0, meta_types_1.ModelTypeT)(exports.TaskPresetT),
    shiftWorkType: (0, meta_types_1.ModelTypeT)(exports.ShiftWorkTypeT),
    terminationType: (0, meta_types_1.ModelTypeT)(exports.TerminationTypeT),
    workType: (0, meta_types_1.ModelTypeT)(exports.WorkTypeT),
    employeePerformance: (0, meta_types_1.ModelTypeT)(exports.EmployeePerformanceT),
    disciplineReview: (0, meta_types_1.ModelTypeT)(exports.DisciplineReviewT),
    appraisers: (0, meta_types_1.ModelTypeT)(exports.AppraiserT),
    mediators: (0, meta_types_1.ModelTypeT)(exports.MediatorT),
    employeeOHS: (0, meta_types_1.ModelTypeT)(exports.EmployeeOHST),
    updateFromPayroll: (0, meta_types_1.ModelTypeT)(exports.UpdateFromPayrollT),
    payrollDBs: (0, meta_types_1.ModelTypeT)(exports.PayrollDatabaseT),
    static: exports.StaticT,
    settings: exports.SettingsT,
    timers: tBox.Record(tBox.String(), tBox.Number()),
    sizes: tBox.Record(tBox.String(), tBox.Number()),
});
exports.EmployeeSelfServeDataT = tBox.Object({
    facilityName: tBox.String(),
    yourselfEmployeeIDs: tBox.Array(tBox.Number()),
    managedEmployeeIDs: tBox.Array(tBox.Number()),
    employees: (0, meta_types_1.ModelStrT)(tBox.Object({
        PrivateID: tBox.Number(),
        PublicID: tBox.String(),
        Title: (0, meta_types_1.MaybeT)(tBox.String()),
        FullName: tBox.String(),
        Surname: tBox.String(),
        FGiven: tBox.String(),
        SGiven: (0, meta_types_1.MaybeT)(tBox.String()),
        Address: (0, meta_types_1.MaybeT)(tBox.String()),
        City: (0, meta_types_1.MaybeT)(tBox.String()),
        State: (0, meta_types_1.MaybeT)(tBox.String()),
        PostCode: (0, meta_types_1.MaybeT)(tBox.String()),
        Phone: (0, meta_types_1.MaybeT)(tBox.String()),
        Mobile: (0, meta_types_1.MaybeT)(tBox.String()),
        Email: (0, meta_types_1.MaybeT)(tBox.String()),
        Gender: (0, meta_types_1.MaybeT)(tBox.String()),
        DOB: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
        StartDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
        EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
        Nok: (0, meta_types_1.MaybeT)(tBox.String()),
        NokPhone: (0, meta_types_1.MaybeT)(tBox.String()),
        NokRelation: (0, meta_types_1.MaybeT)(tBox.String()),
        Contact: (0, meta_types_1.MaybeT)(tBox.String()),
        ContactRelation: (0, meta_types_1.MaybeT)(tBox.String()),
        ContactPhone: (0, meta_types_1.MaybeT)(tBox.String()),
        E_Photo: (0, meta_types_1.MaybeT)(tBox.String()),
        Aboriginal: meta_types_1.BooleanOptionalAnswerT,
        CALD: meta_types_1.BooleanOptionalAnswerT,
        Disability: meta_types_1.BooleanOptionalAnswerT,
    })),
    jobs: (0, meta_types_1.ModelTypeT)(tBox.Object({
        ID: tBox.Number(),
        Company: (0, meta_types_1.MaybeT)(tBox.Number()),
        Classification: tBox.Number(),
        Employee: tBox.Number(),
        JobStartDate: (0, dates_1.DateObjT)(),
        JobEndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    })),
    classifications: (0, meta_types_1.ModelTypeT)(tBox.Object({
        ID: tBox.Number(),
        ClassificationName: tBox.String(),
        AwardName: tBox.String(),
        Active: (0, meta_types_1.MaybeT)(tBox.Number()),
    })),
    roles: (0, meta_types_1.ModelTypeT)(tBox.Object({
        ID: tBox.Number(),
        Name: tBox.String(),
    })),
    employeeRoles: (0, meta_types_1.ModelTypeT)(exports.EmployeeRoleT),
    competencies: (0, meta_types_1.ModelTypeT)(exports.CompetencyT),
    employeeCompetencies: (0, meta_types_1.ModelTypeT)(exports.EmployeeCompetencyT),
    policies: (0, meta_types_1.ModelTypeT)(tBox.Object({
        ID: tBox.Number(),
        Name: tBox.String(),
        FileChecksum: tBox.String(),
    })),
    policyConfirmations: (0, meta_types_1.ModelTypeT)(exports.PolicyConfirmationT),
    positionDescriptions: (0, meta_types_1.ModelTypeT)(exports.PositionDescriptionT),
    contracts: (0, meta_types_1.ModelTypeT)(exports.ContractT),
    notes: tBox.Object({
        employee: (0, meta_types_1.ModelTypeT)(exports.NoteT),
        kb: (0, meta_types_1.ModelTypeT)(exports.NoteT),
    }),
    noteTags: (0, meta_types_1.ModelTypeT)(exports.NoteTagT),
    noteTagLinks: (0, meta_types_1.ModelTypeT)(exports.NoteTagLinkT),
    alerts: tBox.Record(tBox.Number(), tBox.Array(exports.AlertT)),
    settings: exports.SettingsT,
    staticData: tBox.Object({
        superFunds: (0, meta_types_1.ModelTypeT)(exports.SuperFundT),
        salutations: (0, meta_types_1.ModelTypeT)(exports.SalutationT),
    }),
});
//# sourceMappingURL=types-hr.js.map